import { render, staticRenderFns } from "./Page_Signup.vue?vue&type=template&id=58b36584&scoped=true&"
import script from "./Page_Signup.vue?vue&type=script&lang=js&"
export * from "./Page_Signup.vue?vue&type=script&lang=js&"
import style0 from "./Page_Signup.vue?vue&type=style&index=0&id=58b36584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b36584",
  null
  
)

export default component.exports